// 任务状态模块
const state = {
  // 任务列表
  taskList: [],
  // 当前选中的任务
  currentTask: null,
  // 统计数据
  stats: {
    total: 0,
    inProgress: 0,
    completed: 0
  }
}

const mutations = {
  // 设置任务列表
  SET_TASK_LIST(state, taskList) {
    state.taskList = taskList
  },
  // 设置当前任务
  SET_CURRENT_TASK(state, task) {
    state.currentTask = task
  },
  // 添加任务
  ADD_TASK(state, task) {
    state.taskList.push(task)
  },
  // 更新任务
  UPDATE_TASK(state, { index, task }) {
    state.taskList.splice(index, 1, task)
  },
  // 删除任务
  DELETE_TASK(state, index) {
    state.taskList.splice(index, 1)
  },
  // 设置统计数据
  SET_STATS(state, stats) {
    state.stats = stats
  }
}

const actions = {
  // 获取任务列表
  fetchTaskList({ commit }, taskList) {
    commit('SET_TASK_LIST', taskList)
  },
  // 设置当前任务
  setCurrentTask({ commit }, task) {
    commit('SET_CURRENT_TASK', task)
  }
}

const getters = {
  // 进行中的任务
  inProgressTasks: state => state.taskList.filter(t => t.status === 'in_progress'),
  // 已完成的任务
  completedTasks: state => state.taskList.filter(t => t.status === 'completed')
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
